import React from 'react';
import ResponsiveDrawer from '../Drawer/drawer';
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { useNavigate } from "react-router-dom";
import { useOrderDraft } from './OrderDraftContext';
import VariationTableList from '../../ReusableComponents/VariationTableList';
import IconButtonWithBadge from '../../ReusableComponents/CartIcon';
import AddBoxIcon from '@mui/icons-material/AddBox';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { getProducts } from '../../ReusableComponents/functions';
const SelectVariation = () => {
    const navigate = useNavigate();
    const { draft, setProducts, clearCartForProduct } = useOrderDraft();
    const { cartItems, selectedCustomer, selectedProducts } = draft;
    const drawerWidth = 220;

    const [activeMultiplier, setActiveMultiplier] = React.useState(1);
    const [customVal, setCustomVal] = React.useState("");
    const [openAddProductModal, setOpenAddProductModal] = React.useState(false);
    const [allProducts, setAllProducts] = React.useState([]);
    const [modalSearch, setModalSearch] = React.useState("");
    const [multiplierMode, setMultiplierMode] = React.useState("plus"); // "plus" or "minus"
    const [searchQuery, setSearchQuery] = React.useState("");

    const handleSearchSelectedFilter = (e) => {
        setSearchQuery(e.target.value);
    };

    React.useEffect(() => {
        const fetchAllProducts = async () => {
            try {
                const data = await getProducts();
                setAllProducts(data || []);
            } catch (err) {
                console.error("Error fetching products:", err);
            }
        };
        fetchAllProducts();
    }, []);

    const handleNumberSelect = (num) => {
        setActiveMultiplier(num);
        setCustomVal("");
    };

    const handleCustomChange = (e) => {
        const val = e.target.value;
        setCustomVal(val);
        const parsed = parseInt(val, 10);
        if (!isNaN(parsed) && parsed > 0) {
            setActiveMultiplier(parsed);
        } else {
            setActiveMultiplier(1);
        }
    };

    const modalProducts = React.useMemo(() => {
        const remaining = allProducts.filter(
            p => !selectedProducts.some(sp => sp.sku === p.sku)
        );
        if (!modalSearch) return remaining;
        const searchLower = modalSearch.toLowerCase();
        return remaining.filter(
            p => (p.sku || "").toLowerCase().includes(searchLower) ||
                (p.StyleFactory || "").toLowerCase().includes(searchLower)
        );
    }, [allProducts, selectedProducts, modalSearch]);

    const handleAddProduct = (product) => {
        setProducts(product);
        setOpenAddProductModal(false);
        setModalSearch("");
    };

    const handleClearAllQuantities = () => {
        selectedProducts.forEach(product => {
            clearCartForProduct(product.sku);
        });
    };
    const handleClearQTYForProduct = (product) => {
        clearCartForProduct(product.sku);
    };

    // Calculate total pairs and price in cart for display in the layout
    const totals = React.useMemo(() => {
        let totalPairs = 0;
        let totalPrice = 0;
        cartItems.forEach(item => {
            totalPairs += item.unitQuantity;
            totalPrice += (item.unitQuantity * item.unitFinalPrice);
        });
        return { totalPairs, totalPrice };
    }, [cartItems]);

    const handleBack = () => {
        if (selectedCustomer) {
            navigate(`/SelectAProduct/${selectedCustomer.customerid}/${encodeURIComponent(selectedCustomer.StoreName)}`);
        } else {
            navigate('/SelectCustomer');
        }
    };

    const handleNext = () => {
        navigate('/Cart');
    };

    return (
        <div>
            <ResponsiveDrawer heading="Enter Quantities - Create Order" />
            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth - 25}px` },
                    // pb: 12
                }}
                component="main"
            >
                <Toolbar />

                {/* Header section with back / next buttons */}
                <Box sx={{ display: 'flex', justifyItems: 'center', justifyContent: 'space-between', ml: 5, mt: 1, mb: 3, flexWrap: 'wrap', gap: 2 }}>
                    <Button
                        size="small"
                        variant="contained"
                        startIcon={<ArrowBackIcon />}
                        onClick={handleBack}
                        sx={{ fontWeight: 'bold', px: 3, borderRadius: 2 }}
                    >
                        Back
                    </Button>
                    <Box sx={{ textAlign: 'center' }}>
                        {selectedCustomer && (
                            <Typography variant="body2" color="primary" fontWeight="700" sx={{ mt: 0.5, fontSize: '1.6rem' }}>
                                Customer: {selectedCustomer.StoreName}
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField
                            id="search-selected-items"
                            label="Search by SKU or StyleFactory"
                            variant="filled"
                            sx={{ width: 300 }}
                            value={searchQuery}
                            onChange={handleSearchSelectedFilter}
                            InputProps={{
                                endAdornment: searchQuery && (
                                    <InputAdornment position="end">
                                        <IconButton
                                            size="small"
                                            onClick={() => setSearchQuery("")}
                                            edge="end"
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                        {/* <Button
                            variant="outlined"
                            color="error"
                            onClick={handleClearAllQuantities}
                            disabled={selectedProducts.length === 0}
                            sx={{ fontWeight: 'bold', px: 3, borderRadius: 2 }}
                        >
                            Clear All Qty
                        </Button> */}
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddBoxIcon />}
                            onClick={() => setOpenAddProductModal(true)}
                            sx={{ fontWeight: 'bold', px: 4, borderRadius: 2 }}
                        >
                            Add Product
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            endIcon={<ArrowForwardIcon />}
                            onClick={handleNext}
                            disabled={totals.totalPairs === 0}
                            sx={{ fontWeight: 'bold', px: 4, borderRadius: 2 }}
                        >
                            Next (Cart)
                        </Button>

                    </Box>
                </Box>

                {/* Quantity Multiplier Toolbar */}
                <Box sx={{
                    ml: 5,
                    mb: 2,
                    p: 1,
                    backgroundColor: '#fdfdfd',
                    borderRadius: 3,
                    boxShadow: '0 4px 18px rgba(0,0,0,0.03)',
                    border: '1px solid rgba(0, 0, 0, 0.06)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 3,
                    flexWrap: 'wrap',
                    transition: 'all 0.3s ease'
                }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <Typography variant="subtitle2" fontWeight="800" sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '0.75rem' }}>
                            Quantity Multiplier
                        </Typography>
                        <Typography variant="caption" color="text.disabled">
                            Select multiplier & mode, then click a size box to apply
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                        {/* Mode Selectors */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: { xs: 0, md: 'auto' } }}>
                            {(() => {
                                const isCustomActive = activeMultiplier > 20;
                                return (
                                    <TextField
                                        label="Custom"
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        value={customVal}
                                        onChange={handleCustomChange}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment
                                                    position="start"
                                                    sx={{
                                                        height: '100%',
                                                        maxHeight: 'none',
                                                        alignItems: 'center',
                                                        backgroundColor: 'rgba(0,0,0,0.06)',
                                                        borderRight: '1px solid rgba(0,0,0,0.12)',
                                                        px: 1.5,
                                                        ml: -1.5,
                                                        borderTopLeftRadius: '7px',
                                                        borderBottomLeftRadius: '7px',
                                                        color: 'text.secondary',
                                                        fontWeight: '800'
                                                    }}
                                                >
                                                    #
                                                </InputAdornment>
                                            ),
                                            inputProps: { min: 1 },
                                            sx: { borderRadius: 2, height: 38, pl: 1.5, overflow: 'hidden' }
                                        }}
                                        sx={{
                                            width: 140,
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: isCustomActive ? 'primary.main' : 'rgba(0,0,0,0.23)',
                                                    borderWidth: isCustomActive ? '2px' : '1px'
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: isCustomActive ? 'primary.main' : 'rgba(0,0,0,0.87)',
                                                },
                                                boxShadow: isCustomActive ? '0 0 8px rgba(25, 118, 210, 0.25)' : 'none',
                                                transition: 'all 0.2s ease'
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: isCustomActive ? 'primary.main' : 'inherit',
                                                fontWeight: isCustomActive ? 'bold' : 'normal'
                                            }
                                        }}
                                    />
                                );
                            })()}
                        </Box>
                        {/* Numbers 1-20 */}
                        <Box sx={{ display: 'flex', gap: 0.8, flexWrap: 'wrap', alignItems: 'center' }}>
                            {Array.from({ length: 20 }, (_, i) => i + 1).map(num => {
                                const isSelected = activeMultiplier === num;
                                return (
                                    <Button
                                        key={num}
                                        variant={isSelected ? "contained" : "outlined"}
                                        onClick={() => handleNumberSelect(num)}
                                        sx={{
                                            minWidth: 36,
                                            width: 36,
                                            height: 36,
                                            p: 0,
                                            borderRadius: '50%',
                                            fontWeight: isSelected ? '800' : '600',
                                            fontSize: '0.85rem',
                                            borderColor: isSelected ? 'primary.main' : 'rgba(0,0,0,0.12)',
                                            color: isSelected ? '#fff' : 'text.primary',
                                            backgroundColor: isSelected ? 'primary.main' : 'background.paper',
                                            boxShadow: isSelected ? '0 4px 10px rgba(25, 118, 210, 0.25)' : 'none',
                                            '&:hover': {
                                                borderColor: 'primary.main',
                                                backgroundColor: isSelected ? 'primary.main' : 'rgba(25, 118, 210, 0.04)',
                                                transform: 'scale(1.05)'
                                            },
                                            transition: 'all 0.15s ease'
                                        }}
                                    >
                                        {num}
                                    </Button>
                                );
                            })}
                        </Box>
                        <Box sx={{ display: 'flex', gap: 0.5, border: '1px solid rgba(0,0,0,0.08)', p: 0.5, borderRadius: 2, backgroundColor: 'rgba(0,0,0,0.01)' }}>
                            <Button
                                variant={multiplierMode === 'plus' ? 'contained' : 'text'}
                                color="success"
                                onClick={() => setMultiplierMode('plus')}
                                sx={{
                                    minWidth: 42,
                                    width: 42,
                                    height: 36,
                                    p: 0,
                                    borderRadius: 1.5,
                                    fontWeight: '900',
                                    fontSize: '1.2rem',
                                    color: multiplierMode === 'plus' ? '#fff' : 'success.main',
                                    boxShadow: multiplierMode === 'plus' ? '0 2px 6px rgba(46, 125, 50, 0.3)' : 'none',
                                    '&:hover': {
                                        backgroundColor: multiplierMode === 'plus' ? 'success.main' : 'rgba(46, 125, 50, 0.08)'
                                    }
                                }}
                            >
                                +
                            </Button>
                            <Button
                                variant={multiplierMode === 'minus' ? 'contained' : 'text'}
                                color="error"
                                onClick={() => setMultiplierMode('minus')}
                                sx={{
                                    minWidth: 42,
                                    width: 42,
                                    height: 36,
                                    p: 0,
                                    borderRadius: 1.5,
                                    fontWeight: '900',
                                    fontSize: '1.2rem',
                                    color: multiplierMode === 'minus' ? '#fff' : 'error.main',
                                    boxShadow: multiplierMode === 'minus' ? '0 2px 6px rgba(211, 47, 47, 0.3)' : 'none',
                                    '&:hover': {
                                        backgroundColor: multiplierMode === 'minus' ? 'error.main' : 'rgba(211, 47, 47, 0.08)'
                                    }
                                }}
                            >
                                -
                            </Button>
                        </Box>
                    </Box>


                </Box>

                {/* Main Content Area */}
                <Box sx={{ ml: 5, mb: 4 }}>
                    <VariationTableList
                        handleClearQTYForProduct={handleClearQTYForProduct}
                        activeMultiplier={activeMultiplier}
                        multiplierMode={multiplierMode}
                        searchQuery={searchQuery}
                    />
                </Box>

                {/* Sticky summary bar at bottom if there are items */}
                {selectedProducts && selectedProducts.length > 0 && (
                    <Paper
                        elevation={4}
                        sx={{
                            position: 'fixed',
                            bottom: 0,
                            right: 0,
                            width: { sm: `calc(100% - ${drawerWidth}px)` },
                            p: 1.6,
                            borderTop: '1px solid rgba(0, 0, 0, 0.12)',
                            zIndex: 10,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            backgroundColor: '#fafafa'
                        }}
                    >
                        <Box sx={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                            <Typography variant="subtitle1" fontWeight="700" color="text.secondary">
                                Total Selected Items: <span style={{ color: '#1a1a1a', fontWeight: '800' }}>{totals.totalPairs} pairs</span>
                            </Typography>
                            <Typography variant="subtitle1" fontWeight="700" color="text.secondary">
                                Total Price: <span style={{ color: '#1976d2', fontWeight: '800' }}>${totals.totalPrice.toFixed(2)}</span>
                            </Typography>
                        </Box>
                        {/* <Button
                            variant="contained"
                            color="success"
                            size="large"
                            endIcon={<ArrowForwardIcon />}
                            onClick={handleNext}
                            disabled={totals.totalPairs === 0}
                            sx={{ fontWeight: 'bold', px: 4, borderRadius: 2 }}
                        >
                            Review Cart
                        </Button> */}
                    </Paper>
                )}
            </Box>

            {/* Floating cart icon */}
            <IconButtonWithBadge count={totals.totalPairs} />

            {/* Add Product Search Modal */}
            <Dialog
                open={openAddProductModal}
                onClose={() => {
                    setOpenAddProductModal(false);
                    setModalSearch("");
                }}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                    }
                }}
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'bold', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
                    Add Product to Order
                    <IconButton onClick={() => { setOpenAddProductModal(false); setModalSearch(""); }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 3, maxHeight: '60vh', overflowY: 'auto' }}>
                    <TextField
                        fullWidth
                        placeholder="Search products by Style Factory or SKU..."
                        value={modalSearch}
                        onChange={(e) => setModalSearch(e.target.value)}
                        variant="outlined"
                        size="medium"
                        sx={{ mb: 3, mt: 1 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon color="action" />
                                </InputAdornment>
                            ),
                        }}
                    />

                    {modalProducts.length === 0 ? (
                        <Box sx={{ py: 6, textAlign: 'center' }}>
                            <Typography variant="body1" color="text.secondary" fontWeight="500">
                                {allProducts.length === 0 ? "Loading products..." : "No products found matching your search."}
                            </Typography>
                        </Box>
                    ) : (
                        <List sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            {modalProducts.map((product) => (
                                <ListItem
                                    key={product.sku}
                                    sx={{
                                        border: '1px solid rgba(0,0,0,0.06)',
                                        borderRadius: 2,
                                        p: 1.5,
                                        transition: 'all 0.2s',
                                        '&:hover': {
                                            backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                            borderColor: 'primary.light',
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                                        }
                                    }}
                                >
                                    <ListItemAvatar sx={{ mr: 2 }}>
                                        <Avatar
                                            src={product.Picture}
                                            alt={product.StyleFactory}
                                            variant="rounded"
                                            sx={{ width: 110, height: 60, objectFit: 'contain', backgroundColor: '#f9f9f9', border: '1px solid rgba(0,0,0,0.04)' }}
                                        />
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={
                                            <Typography variant="subtitle1" fontWeight="bold" color="text.primary">
                                                {product.StyleFactory}
                                            </Typography>
                                        }
                                        secondary={
                                            <Box sx={{ mt: 0.5 }}>
                                                <Typography variant="body2" color="text.secondary">
                                                    SKU: {product.sku}
                                                </Typography>
                                                {product.Material1 && (
                                                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                                        {product.Material1}
                                                    </Typography>
                                                )}
                                            </Box>
                                        }
                                    />
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', mr: 3 }}>
                                        {product.Size1 && product.Price1 && (
                                            <Typography variant="caption" sx={{ fontWeight: '600', color: '#1976d2' }}>
                                                {product.Size1}: ${product.Price1}
                                            </Typography>
                                        )}
                                        {product.Size2 && product.Price2 && (
                                            <Typography variant="caption" sx={{ fontWeight: '600', color: '#1976d2' }}>
                                                {product.Size2}: ${product.Price2}
                                            </Typography>
                                        )}
                                        {product.Size3 && product.Price3 && (
                                            <Typography variant="caption" sx={{ fontWeight: '600', color: '#1976d2' }}>
                                                {product.Size3}: ${product.Price3}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        startIcon={<AddIcon />}
                                        onClick={() => handleAddProduct(product)}
                                        sx={{ borderRadius: 1.5, fontWeight: 'bold', px: 2 }}
                                    >
                                        Add
                                    </Button>
                                </ListItem>
                            ))}
                        </List>
                    )}
                </DialogContent>
                <DialogActions sx={{ p: 2.5, borderTop: '1px solid rgba(0,0,0,0.08)' }}>
                    <Button
                        onClick={() => { setOpenAddProductModal(false); setModalSearch(""); }}
                        variant="outlined"
                        color="inherit"
                        sx={{ borderRadius: 2, px: 3 }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default SelectVariation;